import Immutable from "seamless-immutable";
import { DEV_TOUCH_STORE } from "./actionTypes";

let initialState = {
  enabled: false,
  hot: false,
  touch: null
};

if (localStorage.getItem("dev") === "true") {
  initialState.enabled = true;
}

if (module.hot) {
  initialState.hot = true;
  console.log("Hot Module Reloading detected.");
}

initialState = Immutable(initialState);

export default function State(state = initialState, action) {
  switch (action.type) {
    case "@@redux/INIT":
      if (state.enabled) {
        console.log("***** Dev enabled *****");
      } else {
        console.log("***** Dev disabled *****");
      }
      break;

    case DEV_TOUCH_STORE:
      state = Immutable.set(state, "touch", new Date());
      break;

    default:
      break;
  }

  return state;
}
